import React from "react";
import { Editor } from "@tinymce/tinymce-react";

const RichTextEditor = ({
  title = "",
  value = "",
  onChange,
  disabled = false,
  name = "textEditor",
  className = "",
  hintText = "",
  destructive = false,
  init = {
    height: '100%',
    width: '100%',
    license_key: "gpl",
    readonly: true,
    menubar: false,
    branding: false,
    statusbar: false,
    elementpath: false,
    selector: "textarea",
    allow_html_in_named_anchor: true,
    plugins: [
      "link",
      "help",
      "code",
      "lists",
      "image",
      "table",
      "media",
      "anchor",
      "editor",
      "advlist",
      "preview",
      "charmap",
      "wordcount",
      "fullscreen",
      "autoresize",
      "visualblocks",
      "searchreplace",
      "insertdatetime",
    ],
    toolbar:
      "undo redo | blocks | " +
      "bold italic underline forecolor | link | alignleft aligncenter " +
      "alignright alignjustify | bullist numlist outdent indent | " +
      "removeformat | image | table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol | help |",

    content_style:
      "body { font-family:Inter,Arial,sans-serif; font-size:14px }",
  },
  ...props
}) => {
  return (
    <div
      className={`rich-text-editor-container${
        destructive ? " destructive" : ""
      }${disabled ? " disabled" : ""} ${className}`}
    >
      {title && <p className="rich-text-editor-title">{title}</p>}
      <Editor
        tinymceScriptSrc="/tinymce/tinymce.min.js"
        onEditorChange={onChange}
        value={value}
        disabled={disabled}
        tagName={name}
        // onInit={(evt, editor) => (editorRef.current = editor)}
        className={`rich-text-editor${disabled ? " disabled" : ""}${
          destructive ? " destructive" : ""
        }`}
        init={init}
        {...props}
      />
      {hintText && <p className="rich-text-editor-hint-text">{hintText}</p>}
    </div>
  );
};

export default RichTextEditor;
